export const CANDIDATES_SOURCES = {
    SMART_MATCH: 'SMART_MATCH',
};

export const LOCATION_DISTANCE_OPTIONS = [
    {label: $filter("translate")("Within 0.5 mile"), value: 0.5},
    {label: $filter("translate")("Within 1 mile"), value: 1},
    {label: $filter("translate")("Within 2 miles"), value: 2},
    {label: $filter("translate")("Within 3 miles"), value: 3},
    {label: $filter("translate")("Within 5 miles"), value: 5},
    {label: $filter("translate")("Within 10 miles"), value: 10},
    {label: $filter("translate")("Within 15 miles"), value: 15},
    {label: $filter("translate")("Within 20 miles"), value: 20},
    {label: $filter("translate")("Within 30 miles"), value: 30},
    {label: $filter("translate")("Within 40 miles"), value: 40},
    {label: $filter("translate")("Within 50 miles"), value: 50},
    {label: $filter("translate")("Within 75 miles"), value: 75},
    {label: $filter("translate")("Within 100 miles"), value: 100},
    {label: $filter("translate")("Within 150 miles"), value: 150},
    {label: $filter("translate")("Within 200 miles"), value: 200}
];

export const TALENT_POOL_USER_VALIDATION_ERRORS = {
    EXISTS_ON_TALENT_POOL: "EXISTS_ON_TALENT_POOL",
    BLOCKED_FROM_REHIRE: "BLOCKED_FROM_REHIRE",
    OPTED_OUT_FROM_BUSINESS: "OPTED_OUT_FROM_BUSINESS"
};